import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import RetailerCss from "../../public/css/retailer/retailer_style.css";
import RetailerHeader from "../retailer/RetailerHeader";
import RetailerSideMenu from "../retailer/RetailerSideMenu";
import Footer from "../patient/Patientfooter";
import { Multiselect } from "multiselect-react-dropdown";
import { reactLocalStorage } from "reactjs-localstorage";
import ReactExport from "react-data-export";
import { normalizeExpiryDate, formatExpiryDateDisplay } from "../../helpers/dateUtils";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//  GST columns in retailer_stock_tbls are nullable strings, so stock uploaded
//  with 0 (or no) GST comes back as null/"" and parseFloat turns it into NaN.
//  Treat anything that is not a finite number as 0.
const toGstNumber = (value) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};

export default class Viewretailers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      availableHome: "nav-item nav-link active",
      runningHome: "nav-item nav-link",
      outHome: "nav-item nav-link",
      expireHome: "nav-item nav-link",
      orderHome: "nav-item nav-link order_book_item ord_med_btn",

      currentHomePanel: "tab-pane fade",
      availableHomePanel: "tab-pane fade",
      runningHomePanel: "tab-pane fade show",
      outHomePanel: "tab-pane fade",
      expireHomePanel: "tab-pane fade",
      selelcteMedicineId: "",
      medicineOptions: "",
      medicineArray: [],
      selectedMedicineList: {},
      selectedMedicineValue: [],
      addMedicineSection: "collapse-hide",
      requestbtn: "request_btn collapse-hide",
      updatebtn: "update_btn collapse-show",
      productUpdatebtn: "update_btn collapse-hide",
      showfields: "col-md-12 collapse-show",
      finalOrder: "collapse-hide",
      retailerCurrentMedicineDetailsView: "",
      retailerLowStockCurrentMedicineDetailsView: "",
      retailerNoStockCurrentMedicineDetailsView: "",
      retailerExpiredStockCurrentMedicineDetailsView: "",
      retailerShortagebookProductsList: "",
      retailerFinalOrderMedicineDetailsView: "",
      shortageBookItemsCount: "0",

      totalAvailableStock: "0",
      totalLowStock: "0",
      totalOutofStock: "0",
      totalExpiredStock: "0",
      totalShortagebookStock: "0",
      showFinalOrderButton: "total_items collapse-hide",
      exportproductsarray: [],
      availableProductsData: [],
      availableDisplayCount: 20,
      lowStockProductsData: [],
      lowStockDisplayCount: 20,
      outStockProductsData: [],
      outStockDisplayCount: 20,
      expiredStockProductsData: [],
      expiredStockDisplayCount: 20,
      search: "",
      alphabetListView: "",
      searchType: "medicine_search",
      searchInput: "input-group col-md-8",
      searchDownload: "col-md-4 download_xls no_padding",
      retailerDetails: [],
    };
    this.fetchmedicinedata = this.fetchmedicinedata.bind(this);
    this.retailerProductsList = this.retailerProductsList.bind(this);
    this.retailerLowStockProductsList = this.retailerLowStockProductsList.bind(
      this
    );
    this.retailerExpiredStockProductsList = this.retailerExpiredStockProductsList.bind(
      this
    );
    this.retailerShortagebookProductsList = this.retailerShortagebookProductsList.bind(
      this
    );
    this.addFinalList = this.addFinalList.bind(this);
  }
  // To get detais after first render
  componentDidMount = () => {
    $(function() {
      var dtToday = new Date();
      var month = dtToday.getMonth() + 1;
      var day = dtToday.getDate();
      var year = dtToday.getFullYear();
      if (month < 10) month = "0" + month.toString();
      if (day < 10) day = "0" + day.toString();

      var minDate = year + "-" + month;

      $("#txtDate").attr("min", minDate);
    });
    let userData = ls.get("retuserObj");
    //let userData = reactLocalStorage.getObject("retuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.retailer_id,
        });
        this.forceUpdate();
      }
    } else {
      window.location.href = "/retailer/login";
    }

    this.getAllDashboardDetails(userData.retailer_id);
    this.alphabetList("available_home-li");
    this.getRetailerDetails(userData.retailer_id);
  };
  // print alphabets
  alphabetList = (id) => {
    //var letters =[];
    //letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const letters = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];
    //$("#"+id).html("");
    //console.log(letters);

    const alphaDetailsView = letters.map((finalLoadedData, num) => {
      return (
        <li
          class="alpha-list"
          id={finalLoadedData}
          onClick={this.searchProduct}
        >
          {finalLoadedData}
        </li>
      );
    });
    this.state.alphabetLists = alphaDetailsView;
    // for (var i = 0;i<letters.length; i++) {
    //   var nextChar = letters.charAt(i);
    //   var letter = "<li>"+nextChar+"</li>";

    //   $("#"+id).append(letter);

    // }
  };

  // Get the Retailer Details
  getRetailerDetails = (retailerId) => {
    Httpconfig.httptokenget(Constant.siteurl + "api/retailer/" + retailerId)
      .then((response) => {
        //console.log("retailer data", response.data.data[0])
        if ((response.data.status = 200 && !response.data.error)) {
          this.setState({ retailerDetails: response.data.data[0] });
          this.retailerProductsList(retailerId);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Get the Stock Details
  getAllDashboardDetails = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/OM/retailerProduct/dashboardStockDetails/" +
        retailerId
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.setState({
            totalAvailableStock: response.data.data[0].availiableStock,
            totalLowStock: response.data.data[0].runningLow,
            totalOutofStock: response.data.data[0].outOfStock,
            totalExpiredStock: response.data.data[0].expiredStock,
            totalShortagebookStock: response.data.data[0].orderBookedStock,
          });
          this.forceUpdate();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  // Refresh the four stock tiles plus whichever tab is currently open, so the
  // counts and the list below them never drift apart.
  refreshStockCounts = () => {
    const retailerId = this.state.retailerId;
    if (!retailerId) return;

    this.getAllDashboardDetails(retailerId);

    const activeTab = "nav-item nav-link active";
    if (this.state.availableHome == activeTab) {
      this.retailerProductsList(retailerId);
    }
    if (this.state.runningHome == activeTab) {
      this.retailerLowStockProductsList(retailerId);
    }
    if (this.state.expireHome == activeTab) {
      this.retailerExpiredStockProductsList(retailerId);
    }
    if (this.state.outHome == activeTab) {
      this.retailerOutStockProductsList(retailerId);
    }
  };

  //    Cliking on the tab
  handleClick = (event) => {
    let id = event.currentTarget.id;
    let retailerId = this.state.retailerId;
    this.state.availableHome = "nav-item nav-link ";
    this.state.runningHome = "nav-item nav-link";
    this.state.outHome = "nav-item nav-link";
    this.state.expireHome = "nav-item nav-link";
    this.state.orderHome = "nav-item nav-link order_book_item ord_med_btn";

    this.state.currentHomePanel = "tab-pane fade";
    this.state.availableHomePanel = "tab-pane fade";
    this.state.runningHomePanel = "tab-pane fade show";
    this.state.outHomePanel = "tab-pane fade";
    this.state.expireHomePanel = "tab-pane fade";

    this.state.addMedicineSection = "collapse-hide";
    this.state.otherSection = "tab-content collapse-show";
    this.state.finalOrder = "collapse-hide";
    this.state.searchDownload = "col-md-4 download_xls no_padding";
    this.state.searchInput = "input-group col-md-8";

    if (id == "available_home-tab") {
      this.state.availableHome = "nav-item nav-link active";
      this.state.availableHomePanel = "tab-pane fade show active";
      this.retailerProductsList(retailerId);
      this.alphabetList("available_home-li");
      this.state.searchType = "medicine_search";
    }
    if (id == "running_home-tab") {
      this.state.runningHome = "nav-item nav-link active";
      this.state.runningHomePanel = "tab-pane fade show active";
      this.retailerLowStockProductsList(retailerId);
      this.alphabetList("running_home-li");
      this.state.searchType = "low_stock";
    }
    if (id == "Expire_home-tab") {
      this.state.expireHome = "nav-item nav-link active";
      this.state.expireHomePanel = "tab-pane fade show active";
      this.retailerExpiredStockProductsList(retailerId);
      this.alphabetList("Expire_home-li");
      this.state.searchType = "expiry_stock";
    }
    if (id == "out_home-tab") {
      this.state.outHome = "nav-item nav-link active";
      this.state.outHomePanel = "tab-pane fade show active";
      this.retailerOutStockProductsList(retailerId);
      this.alphabetList("out_home-li");
      this.state.searchType = "empty_stock";
    }

    if (id == "order_home-tab") {
      this.state.orderHome =
        "nav-item nav-link order_book_item ord_med_btn active ";
      this.state.orderHomePanel = "tab-pane fade show active";
      this.state.searchDownload =
        "col-md-offset-8 col-md-4 download_xls no_padding";
      this.state.searchInput = "input-group col-md-8";
      this.retailerShortagebookProductsList(retailerId);
      this.alphabetList("order_home-li");
    }

    this.forceUpdate();
  };
  // add medicine tabs show/hide
  showAddMedicine = () => {
    this.state.addMedicineSection = "collapse-show";
    this.state.otherSection = "tab-content collapse-hide";
    this.state.availableHome = "nav-item nav-link ";
    this.state.runningHome = "nav-item nav-link";
    this.state.outHome = "nav-item nav-link";
    this.state.expireHome = "nav-item nav-link";
    this.state.orderHome = "nav-item nav-link order_book_item ord_med_btn";
    this.forceUpdate();
  };

  //  fetch master medicine data on search
  fetchmedicinedata(event) {
    let search = event.target.value;
    let medicinesList = [];
    this.state.requestbtn = "request_btn collapse-hide";
    this.state.updatebtn = "update_btn collapse-show";
    this.state.showfields = "col-md-12 collapse-show";
    this.state.search = search;
    if (search != "") {
      Httpconfig.httptokenget(
        Constant.siteurl + "api/OM/retailerProduct/medicine/" + search
      ).then((response) => {
        if (Object.keys(response.data.data).length > 0) {
          const medicineDetailsView = response.data.data.map(
            (finalLoadedData, num) => {
              return (
                <li
                  id={finalLoadedData.id}
                  data-mrp={finalLoadedData.mrp}
                  onClick={this.handleChange}
                >
                  {finalLoadedData.medicineName}
                </li>
              );
            }
          );
          this.state.medicineOptions = medicineDetailsView;
          this.forceUpdate();
        } else {
          this.state.requestbtn = "request_btn collapse-show";
          this.state.updatebtn = "update_btn collapse-hide";
          this.state.showfields = "col-md-12 collapse-hide";
          this.state.medicineOptions = "";
          this.forceUpdate();
        }
      });
    } else {
      this.state.medicineOptions = "";
      this.forceUpdate();
    }
  }
  //  onchanges on master search
  handleChange = (event) => {
    let searched = event.currentTarget.id;
    let medicineName = event.currentTarget.innerText;
    let mrp = event.currentTarget.dataset.mrp;
    this.state.selelcteMedicineId = searched;
    this.state.selelcteMedicineName = medicineName;
    this.state.medicineOptions = "";
    $("#medicineList").val("");
    $("#medicineList").val(medicineName);

    // The MRP input is uncontrolled, so the DOM value and fields must both be set
    // or validation and submit still read an empty MRP.
    if (mrp) {
      $("#mrp_textfield").val(mrp);
      this.state.fields["mrp"] = mrp;
      this.state.errors["mrp"] = "";
    }
    this.forceUpdate();
  };

  // input changes  handle

  handleChangeInput = (field, event) => {
    // alert(field);
    if (field == "expireDate") {
      const storageDate = this.toStorageExpiryDate(event.target.value);
      if (!storageDate) {
        toast.error("Invalid expiry date");
        return;
      }
      const fields = this.state.fields;
      fields[field] = storageDate;
      this.setState({ fields });
      this.state.errors[field] = "";
      return;
    }
    let fields = this.state.fields;
    fields[field] = event.target.value;
    this.setState({ fields });
    this.state.errors[field] = "";
  };

  getExpiryMonthValue = (dateValue) => {
    if (!dateValue) return "";

    const trimmed = String(dateValue).trim();
    if (/^\d{4}-\d{2}$/.test(trimmed)) return trimmed;
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed.slice(0, 7);

    const normalized = normalizeExpiryDate(trimmed);
    if (normalized) {
      const [month, year] = normalized.split("/");
      return `${year}-${month}`;
    }

    const parsed = moment(trimmed, [
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "MM-DD-YYYY",
      "DD/MM/YYYY",
      "YYYY/MM/DD",
      "MM/YYYY",
      "YYYY-MM",
    ], true);

    return parsed.isValid() ? parsed.format("YYYY-MM") : "";
  };

  toStorageExpiryDate = (dateValue) => {
    if (!dateValue) return "";

    const trimmed = String(dateValue).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
    if (/^\d{4}-\d{2}$/.test(trimmed)) return `${trimmed}-01`;

    const normalized = normalizeExpiryDate(trimmed);
    if (normalized) {
      const [month, year] = normalized.split("/");
      return `${year}-${month}-01`;
    }

    const parsed = moment(trimmed, [
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "MM-DD-YYYY",
      "DD/MM/YYYY",
      "YYYY/MM/DD",
    ], true);

    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
  };

  //  add medicine submit

  checkAddMedicineSubmit(event) {
    event.preventDefault();
    const { handle } = this.props.match.params;
    if (this.handleValidation() && handle == undefined) {
      this.AddMedicineDetails(event);
    } else {
      toast.warn("Form has errors.");
    }
  }

  //  add medicine validation

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    var pattern = /^[0-9]{3,20}$/g;
    if (!fields["batchNumber"] || fields["batchNumber"] == 0) {
      errors["batchNumber"] = "";
      formIsValid = false;
      errors["batchNumber"] = "Enter batch number";
    }
    if (!Number(fields["qty"])) {
      errors["qty"] = "";
      formIsValid = false;
      errors["qty"] = "Enter Quantity";
    }
    if (!Number(fields["mrp"])) {
      errors["mrp"] = "";
      formIsValid = false;
      errors["mrp"] = "Enter MRP";
    }

    if (!fields["discount"]) {
      errors["discount"] = "";
      formIsValid = false;
      errors["discount"] = "Enter Discount";
    }
    if (!Number(fields["GSTAmt"])) {
      errors["GSTAmt"] = "";
      formIsValid = false;
      errors["GSTAmt"] = "Enter GSTAmt";
    }
    if (parseFloat(this.state.fields["GSTAmt"]) > 50) {
      errors["GSTAmt"] = "";
      formIsValid = false;
      errors["GSTAmt"] = "Invalid GST";
    }
    // if (!fields["GST"]) {
    //   errors["GST"] = "";
    //   formIsValid = false;
    //   errors["GST"] = "Select GST Type";
    // }
    if (!fields["expireDate"]) {
      errors["expireDate"] = "";
      formIsValid = false;
      errors["expireDate"] = "Enter expiry date";
    }
    // if (fields["expireDate"] != "") {
    //   let expDate = fields["expireDate"];
    //   //let count=expDate.match(/-/g);
    //   let count = expDate.match(/-/g);
    //   let error = 0;
    //   let data = "";

    //   if (count != null) {
    //     data = count.length;
    //   }

    //   if (data == 2) {
    //     let dateString = expDate.split("-");
    //     if (dateString[0].length != 4) {
    //       error = error + 1;
    //     }
    //     if (dateString[1].length > 2) {
    //       error = error + 1;
    //     }
    //     if (dateString[1].length == 0) {
    //       error = error + 1;
    //     }
    //     if (dateString[2].length > 2) {
    //       error = error + 1;
    //     }
    //     if (dateString[2].length == 0) {
    //       error = error + 1;
    //     }
    //     if (error > 0) {
    //       errors["expireDate"] = "Invalid expiry date";
    //     }
    //   } else {
    //     errors["expireDate"] = "Invalid expiry date";
    //   }
    // }
    if (this.state.selelcteMedicineId == "") {
      errors["selectedMedicine"] = "";
      formIsValid = false;
      errors["selectedMedicine"] = "Select Medicine";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  //  add medicine data

  AddMedicineDetails = () => {
    if (!this.state.retailerDetails["gst_type"]) {
      toast.error("Select GST type in settings screen");
      return;
    }
    let finalGst = 0;
    let finalCgst = 0;
    let gstType = this.state.retailerDetails["gst_type"];
    if (gstType == "GST") finalGst = this.state.fields["GSTAmt"] / 2;
    else finalCgst = this.state.fields["GSTAmt"];

    Httpconfig.httptokenpost(Constant.siteurl + "api/OM/retailerProduct", {
      retailer_id: this.state.retailerId,
      medicine_id: this.state.selelcteMedicineId,
      batch: this.state.fields["batchNumber"],
      expiry_date: this.toStorageExpiryDate(this.state.fields["expireDate"]),
      quantity: this.state.fields["qty"],
      mrp: this.state.fields["mrp"],
      form: this.state.fields["form"],
      discount: this.state.fields["discount"],
      vat: "0", //this.state.fields['vat'],
      commission: "0",
      CGST: finalGst,
      SGST: finalGst,
      IGST: finalCgst,
    })
      .then((response) => {
        if (response.data.status == 200 && !response.data.error) {
          this.clearAll();
          this.clearSearch();
          toast.success(response.data.message);
          // The new batch changes the stock tiles, so refresh them here.
          this.refreshStockCounts();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //  clear all add medicine data

  clearAll = () => {
    document.getElementById("addMedicines").reset();
    // reset() only clears the DOM inputs; fields backs validation and submit.
    this.setState({ fields: {}, errors: {} });
  };

  clearSearch = () => {
    $("#medicineList").val("");
    this.state.selelcteMedicineId = "";
    this.state.selelcteMedicineName = "";
  };

  //  preview shortage book data

  previewOrder = () => {
    this.state.finalOrder = "collapse-show";
    this.state.otherSection = "tab-content collapse-hide";
    this.retailerFinalOrderDetails();
    this.forceUpdate();
  };

  // Back show Order Book

  showOrderBook = () => {
    this.state.finalOrder = "collapse-hide";
    this.state.otherSection = "tab-content collapse-show";

    this.forceUpdate();
  };

  // final order details list

  retailerFinalOrderDetails = () => {
    let retailerId = this.state.retailerId;
    let finalorderarray = [];
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/OM/retailerProduct/retailer/finalorder/" +
        retailerId
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerFinalOrderMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                finalorderarray.push({
                  name: finalLoadedData.productMaster_b2c.medicinename,
                  manufacturer: finalLoadedData.productMaster_b2c.manufacturer,
                  quantity: finalLoadedData.quantity,
                });
                return (
                  <div class="final_item">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="item_list">
                          <h4>
                            {finalLoadedData.productMaster_b2c.medicinename}{" "}
                            {finalLoadedData.productMaster_b2c.form}
                          </h4>
                          <h6>
                            {finalLoadedData.productMaster_b2c.manufacturer}
                          </h6>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="strip_list">
                          <p>{finalLoadedData.quantity}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            );

            this.state.retailerFinalOrderMedicineDetailsView = retailerFinalOrderMedicineDetailsView;
            this.state.finalorderarray = finalorderarray;
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Retailers Mapped Products List with Pagination

  retailerProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/OM/retailerProduct/retailer/" + retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const availableProductsData = response.data.data;
            const initialCount = 20;
            const retailerCurrentMedicineDetailsView = this.loadProductsData(
              availableProductsData,
              initialCount
            );

            this.setState({
              availableProductsData: availableProductsData,
              availableDisplayCount: initialCount,
              retailerCurrentMedicineDetailsView: retailerCurrentMedicineDetailsView,
              // built once from the full list, not on every "Load more"
              exportproductsarray: this.buildExportArray(availableProductsData),
            });
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Retailer Low stock Prodcuts List
  retailerLowStockProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/OM/retailerProduct/retailer/lowStock/" +
        retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const lowStockProductsData = response.data.data;
            const initialCount = 20;
            const retailerLowStockCurrentMedicineDetailsView = this.renderLowStockView(
              lowStockProductsData,
              initialCount
            );

            this.setState({
              lowStockProductsData: lowStockProductsData,
              lowStockDisplayCount: initialCount,
              retailerLowStockCurrentMedicineDetailsView: retailerLowStockCurrentMedicineDetailsView,
            });
          } else {
            this.setState({
              retailerLowStockCurrentMedicineDetailsView: "",
              lowStockProductsData: [],
              lowStockDisplayCount: 20,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error loading low stock:", error);
        this.setState({ retailerLowStockCurrentMedicineDetailsView: "" });
        toast.error("Failed to load low stock products");
      });
  };

  handleLoadMoreAvailable = () => {
    const total = this.state.availableProductsData.length;
    if (total === 0) return;

    const nextCount = Math.min(
      this.state.availableDisplayCount + 20,
      total
    );

    const updatedView = this.loadProductsData(
      this.state.availableProductsData,
      nextCount
    );

    this.setState({
      availableDisplayCount: nextCount,
      retailerCurrentMedicineDetailsView: updatedView,
    });
  };

  handleLoadMoreLowStock = () => {
    const total = this.state.lowStockProductsData.length;
    if (total === 0) return;

    const nextCount = Math.min(
      this.state.lowStockDisplayCount + 20,
      total
    );

    const updatedView = this.renderLowStockView(
      this.state.lowStockProductsData,
      nextCount
    );

    this.setState({
      lowStockDisplayCount: nextCount,
      retailerLowStockCurrentMedicineDetailsView: updatedView,
    });
  };

  handleLoadMoreOutStock = () => {
    const total = this.state.outStockProductsData.length;
    if (total === 0) return;

    const nextCount = Math.min(
      this.state.outStockDisplayCount + 20,
      total
    );

    const updatedView = this.renderOutStockView(
      this.state.outStockProductsData,
      nextCount
    );

    this.setState({
      outStockDisplayCount: nextCount,
      retailerNoStockCurrentMedicineDetailsView: updatedView,
    });
  };

  handleLoadMoreExpiredStock = () => {
    const total = this.state.expiredStockProductsData.length;
    if (total === 0) return;

    const nextCount = Math.min(
      this.state.expiredStockDisplayCount + 20,
      total
    );

    const updatedView = this.renderExpiredStockView(
      this.state.expiredStockProductsData,
      nextCount
    );

    this.setState({
      expiredStockDisplayCount: nextCount,
      retailerExpiredStockCurrentMedicineDetailsView: updatedView,
    });
  };

  // Builds the full export (XLS) rows from the complete products list,
  // independent of how many rows are currently rendered on screen.
  buildExportArray = (productsData) => {
    let exportproductsarray = [];

    (productsData || []).forEach((finalLoadedData) => {
      const masterTbl = finalLoadedData.productMaster_b2c;

      if (
        !finalLoadedData.retailer_stock_tbls ||
        finalLoadedData.retailer_stock_tbls.length === 0
      )
        return;

      finalLoadedData.retailer_stock_tbls.forEach((subData) => {
        exportproductsarray.push({
          medicine_id: finalLoadedData.medicine_id,
          medicinename: masterTbl && masterTbl.medicinename ? masterTbl.medicinename : "Unknown Medicine",
          manufacturer: masterTbl && masterTbl.manufacturer ? masterTbl.manufacturer : "",
          packaging: masterTbl && masterTbl?.packaging_detail ? masterTbl?.packaging_detail : "",
          form: masterTbl && masterTbl.form ? masterTbl.form : "",
          batch: subData.batch,
          expiry_date: formatExpiryDateDisplay(subData.expiry_date),
          discount: subData.discount,
          mrp: subData.mrp,
          available_quantity: subData.quantity,
          GST:
            this.state.retailerDetails["gst_type"] === "GST"
              ? toGstNumber(subData.CGST) + toGstNumber(subData.SGST)
              : toGstNumber(subData.IGST),
          productId: subData.product_id,
        });
      });
    });

    return exportproductsarray;
  };

  //common function for searching and loading all products
  loadProductsData = (productsData, limit) => {
    // console.log("productsData", productsData);
    const dataToRender =
      typeof limit === "number" ? productsData.slice(0, limit) : productsData;

    const retailerCurrentMedicineDetailsView = dataToRender.map(
      (finalLoadedData, num) => {
        const masterTbl = finalLoadedData.productMaster_b2c;

        return (
          <React.Fragment key={`product-${finalLoadedData.id || finalLoadedData.medicine_id}-${num}`}>
            {finalLoadedData.retailer_stock_tbls && finalLoadedData.retailer_stock_tbls.length > 0
              ? finalLoadedData.retailer_stock_tbls.map((subData, num1) => {

                  return (
                    <React.Fragment key={`stock-${subData.id || subData.product_id}-${num1}`}>
                        <tr class="stock_row">
                          {num1 === 0 ? (
                            <td rowSpan={Object.keys(finalLoadedData.retailer_stock_tbls).length > 1 ? Object.keys(finalLoadedData.retailer_stock_tbls).length : ""}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  gap: "4px"
                                }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {masterTbl && masterTbl.medicinename ? masterTbl.medicinename : "Unknown Medicine"}
                                </span>
                                <h6 style={{ margin: 0, color: "#666", fontSize: "12px" }}>
                                  {masterTbl && masterTbl.manufacturer ? masterTbl.manufacturer : ""}
                                </h6>
                                {/* New Badge Logic - simplify condition */}
                                {/* {isNewProduct ? <span ...>NEW</span> : null} */}
                              </div>
                            </td>
                          ) : null}

                          {num1 === 0 ? (
                            <td rowSpan={Object.keys(finalLoadedData.retailer_stock_tbls).length > 1 ? Object.keys(finalLoadedData.retailer_stock_tbls).length : ""}>
                              <span style={{ fontWeight: 500, color: "#333" }}>
                                {masterTbl && masterTbl.packaging_detail ? masterTbl.packaging_detail : "-"}
                              </span>
                            </td>
                          ) : null}

                          <td class="stock_batch_td">
                            <input
                              type="text"
                              class="form-control stock_inp stock_batch"
                              defaultValue={subData.batch}
                              id={`batch_${subData.id}-${subData.medicine_id}`}
                              onBlur={this.handleUpdate}
                            />
                          </td>

                          <td class="stock_date_td">
                            <input
                              type="month"
                              class="form-control stock_inp stock_date"
                              defaultValue={this.getExpiryMonthValue(subData.expiry_date)}
                              id={`expirydate_${subData.id}-${subData.medicine_id}`}
                              onBlur={this.handleUpdate}
                            />
                          </td>

                          {this.state.retailerDetails["gst_type"] === "GST" ? (
                            <td>
                              <input
                                type="text"
                                class="form-control stock_inp"
                                defaultValue={
                                  toGstNumber(subData.SGST) +
                                  toGstNumber(subData.CGST)
                                }
                                id={`vat_${subData.id}-${subData.medicine_id}`}
                                name="SGST"
                                onBlur={this.handleUpdate}
                              />
                            </td>
                          ) : (
                            <td>
                              <input
                                type="text"
                                class="form-control stock_inp"
                                defaultValue={toGstNumber(subData.IGST)}
                                id={`vat_${subData.id}-${subData.medicine_id}`}
                                name="IGST"
                                onBlur={this.handleUpdate}
                              />
                            </td>
                          )}

                          <td>
                            <input
                              type="text"
                              class="form-control stock_inp"
                              defaultValue={subData.quantity}
                              onKeyPress={(event) => {
                                if (!/[0-9.]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              id={`quantity_${subData.id}-${subData.medicine_id}`}
                              onBlur={this.handleUpdate}
                            />
                            Strips{" "}
                            {subData.quantity < 5 ? (
                              <img
                                class="strip_down"
                                src="../images/retailer/back-arrow.jpg"
                              />
                            ) : (
                              ""
                            )}
                          </td>

                          <td class="stock_price_td">
                            <input
                              type="text"
                              class="form-control stock_inp stock_price"
                              defaultValue={subData.mrp}
                              onKeyPress={(event) => {
                                if (!/[0-9.]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              id={`mrp_${subData.id}-${subData.medicine_id}`}
                              onBlur={this.handleUpdate}
                            />
                          </td>

                          <td>
                            <input
                              type="text"
                              class="form-control stock_inp"
                              minLength="1"
                              maxLength="2"
                              defaultValue={subData.discount}
                              onKeyPress={(event) => {
                                if (!/[0-9.]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              id={`discount_${subData.id}-${subData.medicine_id}`}
                              onBlur={this.handleUpdate}
                            />
                          </td>

                          {num1 === 0 ? (
                            <td
                              rowSpan={num1 === 1 ? "2" : ""}
                              class="input_td"
                            >
                              <input
                                type="checkbox"
                                name={`med${subData.id}`}
                                id={`${subData.medicine_id},0,${subData.id}`}
                                onChange={this.addShortage}
                              />
                            </td>
                          ) : (
                            <td></td>
                          )}

                          <td>
                            <div class="dropdown">
                              <img
                                onClick={() => {}}
                                class="edit_icon"
                                src="../images/retailer/dottedMenu.svg"
                              />
                              <div
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <a
                                  href="#"
                                  id={masterTbl ? masterTbl.id : ""}
                                  onClick={this.getProductDetailsbyId}
                                >
                                  <img src="../images/retailer/addNewbatch.svg" />
                                  Add Batch
                                </a>
                                <a
                                  href="#"
                                  id={subData.id}
                                  onClick={this.deleteproduct.bind(
                                    this,
                                    subData.id,
                                    subData.medicine_id
                                  )}
                                >
                                  <img src="../images/retailer/delete.svg" />
                                  Delete
                                </a>
                              </div>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                  );
                })
              : ""}
          </React.Fragment>
        );
      }
    );

    return retailerCurrentMedicineDetailsView;
    // if (type == "loadproducts") {
    //   this.setState({
    //     retailerCurrentMedicineDetailsView: [],
    //   });
    //   this.state.retailerCurrentMedicineDetailsView =
    //     retailerCurrentMedicineDetailsView;
    //   this.state.exportproductsarray = exportproductsarray;
    //   this.forceUpdate();
    // }
  }

  renderLowStockView = (productsData, limit) => {
    const dataToRender =
      typeof limit === "number" ? productsData.slice(0, limit) : productsData;

    return dataToRender.map((finalLoadedData, num) => {
      const stockTbls = finalLoadedData.retailer_stock_tbls || [];
      if (stockTbls.length === 0) return null;

      return (
        <React.Fragment key={`lowstock-product-${finalLoadedData.id || finalLoadedData.medicine_id}-${num}`}>
          {stockTbls.map((subData, idx) => (
            <React.Fragment key={`lowstock-${subData.id || subData.product_id}-${idx}`}>
              <tr class="stock_row">
                {idx === 0 ? (
                  <td rowspan={idx === 1 ? "2" : ""}>
                    {finalLoadedData.productMaster_b2c != null
                      ? finalLoadedData.productMaster_b2c.medicinename
                      : "product deletedss"}{" "}
                    <h6>
                      {finalLoadedData.productMaster_b2c != null
                        ? finalLoadedData.productMaster_b2c.manufacturer
                        : "manufacturer deletedss"}
                    </h6>
                  </td>
                ) : (
                  <td rowspan=""> </td>
                )}
                <td>
                  <p>{subData.batch}</p>
                </td>
                <td>
                  <p>{formatExpiryDateDisplay(subData.expiry_date)}</p>
                </td>
                <td>
                  <p>{subData.hsn ? subData.hsn : "---"}</p>
                </td>
                <td>
                  <p>
                    {subData.quantity} Strips{" "}
                    {subData.quantity < 5 ? (
                      <img
                        class="strip_down"
                        src="../images/retailer/back-arrow.jpg"
                      />
                    ) : (
                      ""
                    )}
                  </p>
                </td>
                <td>
                  <p>₹ {subData.mrp}</p>
                </td>
                {idx === 0 ? (
                  <td
                    rowspan={idx === 1 ? "2" : ""}
                    class="input_td"
                  >
                    <input
                      type="checkbox"
                      name={"med" + subData.id}
                      id={
                        subData.medicine_id +
                        "," +
                        "0" +
                        "," +
                        subData.id +
                        ",low"
                      }
                      onChange={this.addShortage}
                    />
                  </td>
                ) : (
                  <td></td>
                )}
                <td>
                  <div class="dropdown">
                    <img
                      onclick="myFunction()"
                      class="edit_icon "
                      src="../images/retailer/dottedMenu.svg"
                    />
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        href="#"
                        id={subData.medicine_id}
                        onClick={this.getProductDetailsbyId}
                      >
                        <img src="../images/retailer/edit.svg" />
                        Edit
                      </a>
                      <a
                        href="#"
                        id={subData.medicine_id}
                        onClick={this.deleteproduct}
                      >
                        <img src="../images/retailer/delete.svg" />
                        Delete
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </React.Fragment>
      );
    });
  };

  renderOutStockView = (productsData, limit) => {
    const dataToRender =
      typeof limit === "number" ? productsData.slice(0, limit) : productsData;

    return dataToRender.map((finalLoadedData, num) => {
      const stockTbls = finalLoadedData.retailer_stock_tbls || [];
      if (stockTbls.length === 0) return null;

      return (
        <React.Fragment key={`outstock-product-${finalLoadedData.id || finalLoadedData.medicine_id}-${num}`}>
          {stockTbls.map((subData, idx) => (
            <React.Fragment key={`outstock-${subData.id || subData.product_id}-${idx}`}>
              <tr class="stock_row">
                {idx === 0 ? (
                  <td rowSpan={stockTbls.length > 1 ? stockTbls.length : ""}>
                    {finalLoadedData.productMaster_b2c
                      ? finalLoadedData.productMaster_b2c.medicinename
                      : "Unknown Medicine"}{" "}
                    <h6>
                      {finalLoadedData.productMaster_b2c
                        ? finalLoadedData.productMaster_b2c.manufacturer
                        : ""}
                    </h6>
                  </td>
                ) : null}
                <td>
                  <p>{subData.batch}</p>
                </td>
                <td>
                  <p>{formatExpiryDateDisplay(subData.expiry_date)}</p>
                </td>
                <td>
                  <p>{subData.hsn ? subData.hsn : "---"}</p>
                </td>
                <td>
                  <p>
                    {subData.quantity} Strips{" "}
                    {subData.quantity < 5 ? (
                      <img
                        class="strip_down"
                        src="../images/retailer/back-arrow.jpg"
                      />
                    ) : (
                      ""
                    )}
                  </p>
                </td>
                <td>
                  <p>₹ {subData.mrp}</p>
                </td>
                {idx === 0 ? (
                  <td
                    rowSpan={stockTbls.length > 1 ? stockTbls.length : ""}
                    class="input_td"
                  >
                    <input
                      type="checkbox"
                      name={"med" + subData.id}
                      id={
                        subData.medicine_id +
                        "," +
                        "0" +
                        "," +
                        subData.id +
                        ",out"
                      }
                      onChange={this.addShortage}
                    />
                  </td>
                ) : (
                  <td></td>
                )}
                <td>
                  <div class="dropdown">
                    <img
                      onClick={() => {}}
                      class="edit_icon "
                      src="../images/retailer/dottedMenu.svg"
                    />
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        href="#"
                        id={subData.id}
                        onClick={this.editproduct}
                      >
                        <img src="../images/retailer/edit.svg" />
                        Edit
                      </a>
                      <a
                        href="#"
                        id={subData.medicine_id}
                        onClick={this.deleteproduct}
                      >
                        <img src="../images/retailer/delete.svg" />
                        Delete
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </React.Fragment>
      );
    });
  };

  renderExpiredStockView = (productsData, limit) => {
    const dataToRender =
      typeof limit === "number" ? productsData.slice(0, limit) : productsData;

    return dataToRender.map((finalLoadedData, num) => {
      const stockTbls = finalLoadedData.retailer_stock_tbls || [];
      if (stockTbls.length === 0) return null;

      return (
        <React.Fragment key={`expired-product-${finalLoadedData.id || finalLoadedData.medicine_id}-${num}`}>
          {stockTbls.map((subData, idx) => (
            <React.Fragment key={`expired-${subData.id || subData.product_id}-${idx}`}>
              <tr class="stock_row">
                {idx === 0 ? (
                  <td rowSpan={stockTbls.length > 1 ? stockTbls.length : ""}>
                    {finalLoadedData.productMaster_b2c
                      ? finalLoadedData.productMaster_b2c.medicinename
                      : "Unknown Medicine"}{" "}
                    <h6>
                      {finalLoadedData.productMaster_b2c
                        ? finalLoadedData.productMaster_b2c.manufacturer
                        : ""}
                    </h6>
                  </td>
                ) : null}
                <td>
                  <p>{subData.batch}</p>
                </td>
                <td>
                  <p>{formatExpiryDateDisplay(subData.expiry_date)}</p>
                </td>
                <td>
                  <p>{subData.hsn ? subData.hsn : "---"}</p>
                </td>
                <td>
                  <p>
                    {subData.quantity} Strips{" "}
                    {subData.quantity < 5 ? (
                      <img
                        class="strip_down"
                        src="https://i.pinimg.com/736x/9e/b6/0e/9eb60ee1602cb5370382c2582ee2d0d1.jpg"
                      />
                    ) : (
                      ""
                    )}
                  </p>
                </td>
                <td>
                  <p>₹ {subData.mrp}</p>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </React.Fragment>
      );
    });
  };

  // Retailer Expire stock Prodcuts List
  retailerExpiredStockProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/OM/retailerProduct/retailer/expiryStock/" +
        retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const expiredStockProductsData = response.data.data;
            const initialCount = 20;
            const retailerExpireStockCurrentMedicineDetailsView = this.renderExpiredStockView(
              expiredStockProductsData,
              initialCount
            );
            this.setState({
              expiredStockProductsData: expiredStockProductsData,
              expiredStockDisplayCount: initialCount,
              retailerExpiredStockCurrentMedicineDetailsView: retailerExpireStockCurrentMedicineDetailsView,
            });
          } else {
            this.setState({
              retailerExpiredStockCurrentMedicineDetailsView: "",
              expiredStockProductsData: [],
              expiredStockDisplayCount: 20,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error loading expired stock:", error);
        this.setState({ retailerExpiredStockCurrentMedicineDetailsView: "" });
        toast.error("Failed to load expired stock products");
      });
  };
  // Retailer out of stock products list
  retailerOutStockProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/OM/retailerProduct/retailer/emptyStock/" +
        retailerId,
      {}
    )
      .then((response) => {
        if (response.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const outStockProductsData = response.data.data;
            const initialCount = 20;
            const retailerOutStockCurrentMedicineDetailsView = this.renderOutStockView(
              outStockProductsData,
              initialCount
            );
            this.setState({
              outStockProductsData: outStockProductsData,
              outStockDisplayCount: initialCount,
              retailerNoStockCurrentMedicineDetailsView: retailerOutStockCurrentMedicineDetailsView,
            });
          } else {
            this.setState({
              retailerNoStockCurrentMedicineDetailsView: "",
              outStockProductsData: [],
              outStockDisplayCount: 20,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error loading out of stock:", error);
        this.setState({ retailerNoStockCurrentMedicineDetailsView: "" });
        toast.error("Failed to load out of stock products");
      });
  };
  // search products of retailer
  searchProduct = (event) => {
    // alert(event.target.value);
    //console.log("searching......");
    let searchString = event.target.value;
    let retailerId = this.state.retailerId;
    let searchType = this.state.searchType;

    if (event.target.value === 0 && event.target.id != "") {
      searchString = event.target.id;
      $(".alpha-list").removeClass("active");
      $("#" + searchString).addClass("active");
    }
    if (searchString != "") {
      // Httpconfig.httptokenget(Constant.siteurl + "api/OM/retailerProduct/search/"+retailerId+"/"+searchString, {
      // })
      Httpconfig.httptokenpost(
        Constant.siteurl + "api/OM/retailerProduct/search",
        {
          retailerId: retailerId,
          search_type: searchType,
          medicineName: searchString,
        }
      )
        .then((response) => {
          if (response.status == 200) {
            if (Object.keys(response.data.data).length > 0) {
              //this.loadProductsData(response.data.data);
              let exportproductsarray = [];
              const searchResults = response.data.data;
              const initialCount = 20;

              const retailerCurrentMedicineDetailsView = searchResults.map(
                (finalLoadedData, num) => {
                  const masterData =
                    finalLoadedData.productMaster_b2c ||
                    (finalLoadedData.retailer_stock_tbls &&
                    finalLoadedData.retailer_stock_tbls.length > 0
                      ? finalLoadedData.retailer_stock_tbls[0].productMaster_b2c
                      : null);
                  const medicineName =
                    (finalLoadedData.medicinename &&
                      finalLoadedData.medicinename.trim()) ||
                    (masterData && masterData.medicinename) ||
                    "Unknown Medicine";
                  const manufacturer =
                    (finalLoadedData.manufacturer &&
                      finalLoadedData.manufacturer.trim()) ||
                    (masterData && masterData.manufacturer) ||
                    "";
                  return (
                    <React.Fragment key={`search-product-${finalLoadedData.id || num}`}>
                      {Object.keys(finalLoadedData.retailer_stock_tbls).length >
                      0
                        ? finalLoadedData.retailer_stock_tbls.map(
                            (subData, num1) => {
                              if (
                                medicineName &&
                                medicineName.trim() !== ""
                              ) {
                                exportproductsarray.push({
                                  medicine_id: finalLoadedData.id,
                                  medicinename: medicineName,
                                  manufacturer: manufacturer,
                                  form: finalLoadedData.form
                                    ? finalLoadedData.form
                                    : "",
                                  batch: subData.batch,
                                  expiry_date: formatExpiryDateDisplay(subData.expiry_date),
                                  discount: subData.discount,
                                  mrp: subData.mrp,
                                  available_quantity: subData.quantity,
                                  GST:
                                    this.state.retailerDetails["gst_type"] ==
                                    "GST"
                                      ? toGstNumber(subData.CGST) +
                                        toGstNumber(subData.SGST)
                                      : toGstNumber(subData.IGST),
                                  productId: subData.product_id,
                                });
                              }
                              return (
                                <React.Fragment key={`search-stock-${subData.id || subData.product_id}-${num1}`}>
                                  <tr class="stock_row">
                                    {num1 == 0 ? (
                                      <td rowspan={num1 == 1 ? "2" : ""}>
                                        {medicineName}{" "}
                                        <h6>
                                          {manufacturer}
                                        </h6>
                                      </td>
                                    ) : (
                                      <td rowspan=""></td>
                                    )}
                                    <td class="new_sec">
                                      {Object.keys(
                                        finalLoadedData.retailer_stock_tbls
                                      ).length ==
                                      num + 1 ? (
                                        <p class="new_btn">new</p>
                                      ) : (
                                        ""
                                      )}
                                      <input
                                        type="text"
                                        class="form-control stock_inp stock_batch"
                                        defaultValue={subData.batch}
                                        id={
                                          "batch_" +
                                          subData.id +
                                          "-" +
                                          subData.medicine_id
                                        }
                                        onBlur={this.handleUpdate}
                                      />
                                    </td>
                                    <td class="stock_date_td">
                                      <input
                                        type="month"
                                        class="form-control stock_inp stock_date"
                                        defaultValue={this.getExpiryMonthValue(subData.expiry_date)}
                                        id={
                                          "expirydate_" +
                                          subData.id +
                                          "-" +
                                          subData.medicine_id
                                        }
                                        onBlur={this.handleUpdate}
                                      />
                                    </td>
                                    <td>
                                      {this.state.retailerDetails["gst_type"] ==
                                      "GST" ? (
                                        <input
                                          type="text"
                                          class="form-control stock_inp"
                                          defaultValue={
                                            toGstNumber(subData.CGST) +
                                            toGstNumber(subData.SGST)
                                          }
                                          id={
                                            "vat_" +
                                            subData.id +
                                            "-" +
                                            subData.medicine_id
                                          }
                                          onBlur={this.handleUpdate}
                                        />
                                      ) : (
                                        <input
                                          type="text"
                                          class="form-control stock_inp"
                                          defaultValue={toGstNumber(
                                            subData.IGST
                                          )}
                                          id={
                                            "vat_" +
                                            subData.id +
                                            "-" +
                                            subData.medicine_id
                                          }
                                          onBlur={this.handleUpdate}
                                        />
                                      )}
                                      {/* <input
                                      type="text"
                                      class="form-control stock_inp"
                                      defaultValue={subData.vat}
                                      id={
                                        "vat_" +
                                        subData.id +
                                        "-" +
                                        subData.medicine_id
                                      }
                                      onBlur={this.handleUpdate}
                                    /> */}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        class="form-control stock_inp"
                                        defaultValue={subData.quantity}
                                        id={
                                          "quantity_" +
                                          subData.id +
                                          "-" +
                                          subData.medicine_id
                                        }
                                        onBlur={this.handleUpdate}
                                      />
                                      Strips{" "}
                                      {subData.quantity < 5 ? (
                                        <img
                                          class="strip_down"
                                          src="../images/retailer/back-arrow.jpg"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td class="stock_price_td">
                                      <input
                                        type="text"
                                        class="form-control stock_inp stock_price"
                                        defaultValue={subData.mrp}
                                        id={
                                          "mrp_" +
                                          subData.id +
                                          "-" +
                                          subData.medicine_id
                                        }
                                        onBlur={this.handleUpdate}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        class="form-control stock_inp"
                                        defaultValue={subData.discount}
                                        id={
                                          "discount_" +
                                          subData.id +
                                          "-" +
                                          subData.medicine_id
                                        }
                                        onBlur={this.handleUpdate}
                                      />
                                    </td>
                                    {num1 == 0 ? (
                                      <td
                                        rowspan={num1 == 1 ? "2" : ""}
                                        class="input_td"
                                      >
                                        <input
                                          type="checkbox"
                                          name={"med" + subData.id}
                                          id={
                                            subData.medicine_id +
                                            "," +
                                            "0" +
                                            "," +
                                            subData.id
                                          }
                                          onChange={this.addShortage}
                                        />
                                      </td>
                                    ) : (
                                      <td></td>
                                    )}
                                    <td>
                                      <div class="dropdown">
                                        <img
                                          onclick="myFunction()"
                                          class="edit_icon "
                                          src="../images/retailer/dottedMenu.svg"
                                        />
                                        <div
                                          class="dropdown-menu"
                                          aria-labelledby="dropdownMenuButton"
                                        >
                                          <a
                                            href="#"
                                            id={
                                              finalLoadedData
                                                ? finalLoadedData.id
                                                : ""
                                            }
                                            onClick={this.getProductDetailsbyId}
                                          >
                                            <img src="../images/retailer/addNewbatch.svg" />
                                            Add Batch
                                          </a>
                                          <a
                                            href="#"
                                            id={subData.id}
                                            onClick={this.deleteproduct.bind(
                                              this,
                                              subData.id,
                                              subData.medicine_id
                                            )}
                                          >
                                            <img src="../images/retailer/delete.svg" />
                                            Delete
                                          </a>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          )
                        : ""}
                    </React.Fragment>
                  );
                }
              );
              // this.setState({
              //   retailerCurrentMedicineDetailsView:
              //     retailerCurrentMedicineDetailsView,
              //   exportproductsarray: exportproductsarray,
              // });
              // this.forceUpdate();

              if (this.state.availableHome == "nav-item nav-link active") {
                const limitedView = this.loadProductsData(searchResults, initialCount);
                this.setState({
                  retailerCurrentMedicineDetailsView: limitedView,
                  availableProductsData: searchResults,
                  availableDisplayCount: initialCount,
                });
              }
              if (this.state.runningHome == "nav-item nav-link active") {
                const limitedView = this.renderLowStockView(searchResults, initialCount);
                this.setState({
                  retailerLowStockCurrentMedicineDetailsView: limitedView,
                  lowStockProductsData: searchResults,
                  lowStockDisplayCount: initialCount,
                });
              }
              if (this.state.expireHome == "nav-item nav-link active") {
                const limitedView = this.renderExpiredStockView(searchResults, initialCount);
                this.setState({
                  retailerExpiredStockCurrentMedicineDetailsView: limitedView,
                  expiredStockProductsData: searchResults,
                  expiredStockDisplayCount: initialCount,
                });
              }
              if (this.state.outHome == "nav-item nav-link active") {
                const limitedView = this.renderOutStockView(searchResults, initialCount);
                this.setState({
                  retailerNoStockCurrentMedicineDetailsView: limitedView,
                  outStockProductsData: searchResults,
                  outStockDisplayCount: initialCount,
                });
              }

              this.setState({
                exportproductsarray: exportproductsarray,
              });
              // const retailerCurrentMedicineDetailsView = response.data.data.map(
              //   (finalLoadedData, num) => {
              //     return (
              //       <React.Fragment>
              //         {Object.keys(finalLoadedData.retailer_stock_tbls).length >
              //         0
              //           ? finalLoadedData.retailer_stock_tbls.map(
              //               (subData, num) => {
              //                 // alert(Object.keys(finalLoadedData.retailer_stock_tbls).length);
              //                 return (
              //                   <React.Fragment>
              //                     <tr class="stock_row">
              //                       {num == 0 ? (
              //                         <td rowspan={num == 1 ? "2" : ""}>
              //                           {finalLoadedData.medicinename}{" "}
              //                           <h6>{finalLoadedData.manufacturer}</h6>
              //                         </td>
              //                       ) : (
              //                         <td rowspan=""> </td>
              //                       )}
              //                       <td>
              //                         <p>{subData.batch}</p>
              //                       </td>
              //                       <td>
              //                         <p>{subData.expiry_date}</p>
              //                       </td>
              //                       <td>
              //                         <p>{subData.hsn ? subData.hsn : "---"}</p>
              //                       </td>
              //                       <td>
              //                         <p>
              //                           {subData.quantity} Strips{" "}
              //                           {subData.quantity < 5 ? (
              //                             <img
              //                               class="strip_down"
              //                               src="../images/retailer/back-arrow.jpg"
              //                             />
              //                           ) : (
              //                             ""
              //                           )}
              //                         </p>
              //                       </td>
              //                       <td>
              //                         <p> {subData.mrp}</p>
              //                       </td>
              //                       {/* <td>
              //                         <p> {subData.mrp}</p>
              //                       </td> */}
              //                       {num == 0 ? (
              //                         <td
              //                           rowspan={num == 1 ? "2" : ""}
              //                           class="input_td"
              //                         >
              //                           <input
              //                             type="checkbox"
              //                             name={"med" + subData.id}
              //                             id={
              //                               subData.medicine_id +
              //                               "," +
              //                               "0" +
              //                               "," +
              //                               subData.id
              //                             }
              //                             onChange={this.addShortage}
              //                           />
              //                         </td>
              //                       ) : (
              //                         <td></td>
              //                       )}
              //                       <td>
              //                         <div class="dropdown">
              //                           <img
              //                             onclick="myFunction()"
              //                             class="edit_icon "
              //                             src="../images/retailer/dottedMenu.svg"
              //                           />
              //                           <div
              //                             class="dropdown-menu"
              //                             aria-labelledby="dropdownMenuButton"
              //                           >
              //                             <a
              //                               href="#"
              //                               id={subData.id}
              //                               onClick={this.editproduct}
              //                             >
              //                               <img src="../images/retailer/edit.svg" />
              //                               Edit
              //                             </a>
              //                             <a
              //                               href="#"
              //                               id={subData.medicine_id}
              //                               onClick={this.deleteproduct}
              //                             >
              //                               <img src="../images/retailer/delete.svg" />
              //                               Delete
              //                             </a>
              //                           </div>
              //                         </div>
              //                       </td>
              //                     </tr>
              //                   </React.Fragment>
              //                 );
              //               }
              //             )
              //           : ""}
              //       </React.Fragment>
              //     );
              //   }
              // );
              // if (this.state.availableHome == "nav-item nav-link active") {
              //   this.state.retailerCurrentMedicineDetailsView =
              //     retailerCurrentMedicineDetailsView;
              //   this.forceUpdate();
              // }
              // if (this.state.runningHome == "nav-item nav-link active") {
              //   this.state.retailerLowStockCurrentMedicineDetailsView =
              //     retailerCurrentMedicineDetailsView;
              //   this.forceUpdate();
              // }
              // if (this.state.expireHome == "nav-item nav-link active") {
              //   this.state.retailerExpireStockCurrentMedicineDetailsView =
              //     retailerCurrentMedicineDetailsView;
              //   this.forceUpdate();
              // }
              // if (this.state.outHome == "nav-item nav-link active") {
              //   this.state.retailerOutStockCurrentMedicineDetailsView =
              //     retailerCurrentMedicineDetailsView;
              //   this.forceUpdate();
              // }
            } else {
              if (this.state.availableHome == "nav-item nav-link active") {
                this.setState({
                  retailerCurrentMedicineDetailsView: "No Results found",
                });
              }
              if (this.state.runningHome == "nav-item nav-link active") {
                this.setState({
                  retailerLowStockCurrentMedicineDetailsView: "No Results found",
                });
              }
              if (this.state.expireHome == "nav-item nav-link active") {
                this.setState({
                  retailerExpiredStockCurrentMedicineDetailsView: "No Results found",
                });
              }
              if (this.state.outHome == "nav-item nav-link active") {
                this.setState({
                  retailerNoStockCurrentMedicineDetailsView: "No Results found",
                });
              }
            }
          }
        })
        .catch((error) => {
          console.error("Error searching products:", error);
          toast.error("Failed to search products");
        });
    } else {
      if (this.state.availableHome == "nav-item nav-link active") {
        this.retailerProductsList(retailerId);
      }
      if (this.state.runningHome == "nav-item nav-link active") {
        this.retailerLowStockProductsList(retailerId);
      }
      if (this.state.expireHome == "nav-item nav-link active") {
        this.retailerExpiredStockProductsList(retailerId);
      }
      if (this.state.outHome == "nav-item nav-link active") {
        this.retailerOutStockProductsList(retailerId);
      }
    }
  };

  showUpload = () => {
    window.location.href = "./Retaileruploadstock";
  };
  // delete products stock

  deleteproduct = (productId, medicineId) => {
    //let productId=event.currentTarget.id;
    let retailerId = this.state.retailerId;
    Httpconfig.httptokendelete(
      Constant.siteurl +
        "api/OM/retailerProduct/" +
        retailerId +
        "/" +
        medicineId +
        "/" +
        productId,
      {}
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.getAllDashboardDetails(retailerId);
          toast.success(response.data.message);
          if (this.state.availableHome == "nav-item nav-link active") {
            this.retailerProductsList(retailerId);
          }
          if (this.state.runningHome == "nav-item nav-link active") {
            this.retailerLowStockProductsList(retailerId);
          }
          if (this.state.expireHome == "nav-item nav-link active") {
            this.retailerExpiredStockProductsList(retailerId);
          }
          if (this.state.outHome == "nav-item nav-link active") {
            this.retailerOutStockProductsList(retailerId);
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  // Add medinces to Shortage book
  addShortage = (event) => {
    let retailerId = this.state.retailerId;
    let data = event.currentTarget.id;
    let result = data.split(",");
    let medicineId = result[0];
    let id = result[2];
    let qty = result[1];
    if (document.getElementById(event.currentTarget.id).checked == true) {
      Httpconfig.httptokenpost(
        Constant.siteurl + "api/OM/retailerProduct/retailer/shortageBook",
        {
          retailer_id: retailerId,
          medicine_id: medicineId,
          quantity: qty,
        }
      )
        .then((response) => {
          if (response.data.status == 200) {
            toast.success(response.data.message);
            this.getAllDashboardDetails(retailerId);

            document.getElementById(data).checked = false;
          }
          if (response.data.status == 204) {
            toast.error(response.data.message);
            document.getElementById(data).checked = false;
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      Httpconfig.httptokendelete(
        Constant.siteurl + "api/OM/retailerProduct/retailer/shortageBook/" + id
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
  retailerShortagebookProductsList = (retailerId) => {
    Httpconfig.httptokenget(
      Constant.siteurl +
        "api/OM/retailerProduct/shortageBook/retailer/" +
        retailerId
    )
      // Httpconfig.httptokenget(Constant.siteurl + "api/OM/retailerProduct/retailer/finalorder/"+retailerId,)
      .then((response) => {
        let orderallarray = [];
        if (response.data.status == 200) {
          const dataList = response.data.data || [];
          let shortageBookItemsCount = dataList.length;
          
          if (shortageBookItemsCount > 0) {
            const retailerStortagebookMedicineDetailsView = dataList.map(
              (finalLoadedData, num) => {
                const masterTbl = finalLoadedData.productMaster_b2c;
                const medicineName = masterTbl ? masterTbl.medicinename : "Unknown Medicine";
                const manufacturer = masterTbl ? masterTbl.manufacturer : "";
                const masterId = masterTbl ? masterTbl.id : `unknown-${num}`;
                
                if (masterTbl) {
                   orderallarray.push({
                      orderquantity: masterTbl.id,
                   });
                }
                
                return (
                  <tr key={`shortage-${finalLoadedData.id || num}`}>
                    <td>
                      {medicineName}{" "}
                      <h6>{manufacturer}</h6>
                    </td>
                    <td>
                      <div class="qty">
                        <span
                          class="minus bg-dark"
                          id={
                            finalLoadedData.id +
                            "-" +
                            masterId
                          }
                          onClick={this.qtyDecrement}
                        >
                          -
                        </span>
                        <input
                          type="number"
                          class="count"
                          name="qty"
                          defaultValue={
                            finalLoadedData.quantity
                              ? finalLoadedData.quantity
                              : "0"
                          }
                          id={"txt-" + masterId}
                          onKeyUp={this.updateQty}
                        />
                        <span
                          class="plus bg-dark"
                          id={
                            finalLoadedData.id +
                            "-" +
                            masterId
                          }
                          onClick={this.qtyIncrement}
                        >
                          +
                        </span>
                      </div>
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        class="add_one"
                        name={masterId}
                        id={"shrt-" + masterId}
                        onChange={this.addFinalList}
                      />{" "}
                      Add
                    </td>
                    <td
                      class="delete_txt"
                      onClick={this.deleteShortageBook.bind(
                        this,
                        finalLoadedData.medicine_id
                      )}
                    >
                      <img
                        src="../images/retailer/RedDeleteMedicine.svg"
                        id={finalLoadedData.medicine_id}
                      />{" "}
                      Delete
                    </td>
                  </tr>
                );
              }
            );
            this.state.retailerShortagebookProductsList = retailerStortagebookMedicineDetailsView;
            this.state.shortageBookItemsCount = shortageBookItemsCount;
            this.state.showFinalOrderButton = "total_items collapse-show";
            this.state.orderallarray = orderallarray;
            this.forceUpdate();
          } else {
            this.state.retailerShortagebookProductsList = "";
            this.state.shortageBookItemsCount = "0";
            this.state.showFinalOrderButton = "total_items collapse-hide";
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // shortage book quanatity decrement

  qtyDecrement = (event) => {
    //let id=event.currentTarget.id;
    let data = event.currentTarget.id.split("-");
    let id = data[0];
    let medicineId = data[1];
    let qty = $("#txt-" + medicineId).val();
    //alert("in");

    if (qty > 0) {
      qty = qty - 1;
      $("#txt-" + medicineId).val(qty);
      this.updateShortagebookQuantity(id, medicineId, qty);
    }
    //alert(qty);
  };

  // shortage book quanatity Increment
  qtyIncrement = (event) => {
    //let id=event.currentTarget.id;
    let data = event.currentTarget.id.split("-");
    let id = data[0];
    let medicineId = data[1];
    let qty = $("#txt-" + medicineId).val();

    if (qty >= 0) {
      qty = parseInt(qty) + 1;
      $("#txt-" + medicineId).val(qty);
      this.updateShortagebookQuantity(id, medicineId, qty);
    }
  };

  // shortage book quanatity enter
  updateQty = (event) => {
    //alert(event.target.value);
    let data = event.currentTarget.id.split("-");
    let id = data[1];
    let qty = event.target.value;
    // this.updateShortagebookQuantity(id,qty);
  };

  // add shortage book to final order list

  addFinalList = (event) => {
    let data = event.currentTarget.id.split("-");
    let id = data[1];
    if (document.getElementById(event.currentTarget.id).checked == true) {
      let qty = $("#txt-" + id).val();
      if (qty == 0) {
        document.getElementById(event.currentTarget.id).checked = false;
        toast.error("Quantity should not be zero");
      } else {
        this.updateFinalOrder(id, qty);
      }
    } else {
      alert("out");
    }
  };

  // add/update to theShortage book list
  updateShortagebookQuantity = (id, medicineid, qty) => {
    let retailerId = this.state.retailerId;
    Httpconfig.httptokenput(
      Constant.siteurl + "api/OM/retailerProduct/retailer/shortageBook/" + id,
      {
        retailer_id: retailerId,
        medicineid: medicineid,
        quantity: qty,
      }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // add/update to the final order list
  updateFinalOrder = (medicineid, qty) => {
    let retailerId = this.state.retailerId;
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/retailerProduct/retailer/finalorder",
      {
        finalorder: [
          {
            retailer_id: retailerId,
            medicine_id: medicineid,
            quantity: qty,
          },
        ],
      }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // delte item from shortage book

  deleteShortageBook = (id) => {
    //alert("in");
    //let id=event.currentTarget.id;
    Httpconfig.httptokendelete(
      Constant.siteurl +
        "api/OM/retailerProduct/retailer/shortageBook/" +
        this.state.retailerId +
        "/" +
        id
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.retailerShortagebookProductsList(this.state.retailerId);
          this.getAllDashboardDetails(this.state.retailerId);
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //Order all products to shortage book

  orderAllShortageBook = (event) => {
    var Totqty = this.state.orderallarray;
    var errorCount = 0;
    if (Object.keys(Totqty).length > 0) {
      // console.log("Totqty", Totqty);
      for (var qty = 0; qty < Object.keys(Totqty).length; qty++) {
        let id = Totqty[qty].orderquantity;
        let allQty = $("#txt-" + id).val();

        // if (Totqty[qty].orderquantity == 0) {
        //   errorCount++;
        // }
        if (allQty == 0) {
          errorCount++;
        }
      }
      if (errorCount > 0) {
        toast.error("order all quantity should not be zero");
        document.getElementById(event.currentTarget.id).checked = false;
        return false;
      } else {
        $(".add_one").prop("checked", true);
      }
    }

    if (document.getElementById(event.currentTarget.id).checked == true) {
      Httpconfig.httptokenpost(
        Constant.siteurl +
          "api/OM/retailerProduct/shortageBook/orderAll/retailer",
        {
          retailer_id: this.state.retailerId,
        }
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            //  this.retailerShortagebookProductsList(this.state.retailerId);
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      Httpconfig.httptokendelete(
        Constant.siteurl +
          "api/OM/retailerProduct/deleteAllShortageBookFinalOrder/" +
          this.state.retailerId
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            this.retailerShortagebookProductsList(this.state.retailerId);
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  // delete all items in the shortage book

  deleteAllShortageBook = () => {
    Httpconfig.httptokendelete(
      Constant.siteurl +
        "api/OM/retailerProduct/deleteAllShortageBookFinalOrder/" +
        this.state.retailerId
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          this.retailerShortagebookProductsList(this.state.retailerId);
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // print shortage book div

  printDiv = () => {
    var printContents = document.getElementById("final_ord_details").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  // add Product request
  addProductRequest = () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["manufacturer"]) {
      errors["manufacturer"] = "";
      formIsValid = false;
      errors["manufacturer"] = "Enter manufacturer name";
    }
    if (!fields["UOM"]) {
      errors["UOM"] = "";
      formIsValid = false;
      errors["UOM"] = "Enter Unit of Measurment";
    }
    // if (!fields["mrp"]) {
    //     errors["mrp"] = "";
    //     formIsValid = false;
    //     errors["mrp"] = "Enter MRP";
    // }

    this.setState({ errors: errors });
    if (formIsValid == true) {
      Httpconfig.httptokenpost(Constant.siteurl + "api/OM/productRequest", {
        clinic_id: "",
        medicineid: "",
        medicine_name: this.state.search,
        medicine_main: fields["manufacturer"],
        medicine_type: fields["form"],
        uom: fields["UOM"],
        strength: fields["strength"],
        mrp: fields["MRP"],
        description: "",
        compositions: "",
        retailer: this.state.retailerId,
      })
        .then((response) => {
          if ((response.data.status = 200)) {
            // this.retailerShortagebookProductsList(this.state.retailerId);
            this.state.search = "";
            this.clearAll();

            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      toast.error("forms has erros");
    }
  };

  //inline update the prodcuts,stock

  // handleUpdate = (event) => {
  //   alert("called", event.currentTarget.value);

  //   console.log("called", event.currentTarget.value);
  //   this.forceUpdate();
  //   let clickedId = event.currentTarget.id;
  //   let ids = clickedId.split("_");
  //   let batch = document.getElementById("batch_" + ids[1]).value;
  //   let expiry_date = document.getElementById("expirydate_" + ids[1]).value;
  //   let vat = document.getElementById("vat_" + ids[1]).value;
  //   let quantity = document.getElementById("quantity_" + ids[1]).value;
  //   let mrp = document.getElementById("mrp_" + ids[1]).value;
  //   let discount = document.getElementById("discount_" + ids[1]).value;
  //   console.log("up value", $("#discount_" + ids[1]).value);
  //   let idData = ids[1].split("-");
  //   let medicineId = idData[1];
  //   let id = idData[0];

  //   Httpconfig.httptokenput(
  //     Constant.siteurl + "api/OM/retailerProduct/stock/" + id,
  //     {
  //       retailer_id: this.state.retailerId,
  //       medicine_id: medicineId,
  //       batch: batch,
  //       expiry_date: expiry_date,
  //       quantity: quantity,
  //       mrp: mrp,
  //       discount: discount,
  //       vat: vat,
  //       commission: "0",
  //       CGST: "0",
  //       SGST: "0",
  //       IGST: "0",
  //     }
  //   )
  //     .then((response) => {
  //       if ((response.data.status = 200)) {
  //         // this.retailerShortagebookProductsList(this.state.retailerId);
  //         //toast.success(response.data.message);
  //       }
  //     })
  //     .catch((error) => {
  //       toast.error(error);
  //     });
  // };

  handleUpdate = (event, gstType) => {
    // console.log("called", event.currentTarget);
    this.forceUpdate();
    let postObj = {};
    let clickedId = event.currentTarget.id;
    let ids = clickedId.split("_");
    // console.log("ids", ids);
    if (ids[0] == "batch") {
      postObj.batch = event.currentTarget.value;
    } else if (ids[0] == "expirydate") {
      const normalizedExpiry = this.toStorageExpiryDate(event.currentTarget.value);
      if (!normalizedExpiry) {
        toast.error("Invalid expiry date");
        return;
      }
      postObj.expiry_date = normalizedExpiry;
      // if (moment(postObj.expiry_date, "YYYY-MM-DD", true).isValid()) {
      // } else {
      //   toast.error("Please Enter Valid date formate DD/MM/YYYY");
      //   $("#" + clickedId).val("");
      //   return false;
      // }
    } else if (ids[0] == "vat") {
      let gstType = this.state.retailerDetails["gst_type"];
      if (gstType == "GST") {
        let GST = toGstNumber(event.currentTarget.value) / 2;
        postObj.SGST = GST;
        postObj.CGST = GST;
      } else {
        postObj.IGST = toGstNumber(event.currentTarget.value);
      }
      //postObj.vat = event.currentTarget.value;
    } else if (ids[0] == "quantity") {
      postObj.quantity = event.currentTarget.value;
    } else if (ids[0] == "mrp") {
      if (event.currentTarget.value <= 0) {
        toast.error("MRP should greater than zero");
        $("#" + clickedId).val("");
        return;
      }
      postObj.mrp = event.currentTarget.value;
    } else if (ids[0] == "discount") {
      postObj.discount = event.currentTarget.value;
    }

    let idData = ids[1].split("-");
    let medicineId = idData[1];
    let id = idData[0];
    postObj.retailer_id = this.state.retailerId;
    postObj.medicine_id = medicineId;
    //console.log("up value", postObj);

    Httpconfig.httptokenput(
      Constant.siteurl + "api/OM/retailerProduct/stock/" + id,
      postObj
    )
      .then((response) => {
        if ((response.data.status = 200 && !response.data.error)) {
          // this.retailerShortagebookProductsList(this.state.retailerId);
          toast.success(response.data.message);
          // Quantity / expiry edits move a medicine between the stock tiles.
          this.refreshStockCounts();
        } else {
          event.currentTarget.value = 10;
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //Get Product details by Id
  // editproduct=()=>{

  //  }

  getProductDetailsbyId = (event) => {
    let medicineId = event.currentTarget.id;
    this.state.selelcteMedicineId = medicineId;
    if (medicineId != "") {
      Httpconfig.httptokenget(
        Constant.siteurl + "api/OM/retailerProduct/" + medicineId
      )
        .then((response) => {
          if ((response.data.status = 200)) {
            this.showAddMedicine();
            //console.log("runningHome", this.state.availableHome);

            let medicineName =
              response.data.data[0].productMaster_b2c.medicinename;
            let manufacturer =
              response.data.data[0].productMaster_b2c.manufacturer;
            let form = response.data.data[0].productMaster_b2c.form;
            $("#medicineList").val(
              medicineName + " | " + form + " | " + manufacturer
            );
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
  handleAll = (event) => {
    let searchString = event.currentTarget.id;
    $(".alpha-list").removeClass("active");
    $("#" + searchString).addClass("active");
    this.retailerProductsList(this.state.retailerId);
  };
  render() {
    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section id="Pharmacy_dashboard">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-10 col-md-10 Pharma_Content">
                <section class="manage_section">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-12">
                        <nav class="p_nav">
                          <div
                            class="nav nav-tabs nav-fill"
                            id="nav-tab"
                            role="tablist"
                          >
                            <a
                              class={this.state.availableHome}
                              id="available_home-tab"
                              data-toggle="tab"
                              href="#available_home"
                              role="tab"
                              aria-controls="available-home"
                              aria-selected="true"
                              onClick={this.handleClick}
                            >
                              Total Available in stock
                              <p>{this.state.totalAvailableStock}</p>
                            </a>
                            <a
                              class={this.state.runningHome}
                              id="running_home-tab"
                              data-toggle="tab"
                              href="#running_home"
                              role="tab"
                              aria-controls="running_home"
                              aria-selected="false"
                              onClick={this.handleClick}
                            >
                              Running Low<p>{this.state.totalLowStock}</p>
                            </a>
                            <a
                              class={this.state.outHome}
                              id="out_home-tab"
                              data-toggle="tab"
                              href="#out_home"
                              role="tab"
                              aria-controls="out_home"
                              aria-selected="false"
                              onClick={this.handleClick}
                            >
                              Out of Stock <p>{this.state.totalOutofStock}</p>
                            </a>
                            <a
                              class={this.state.expireHome}
                              id="Expire_home-tab"
                              data-toggle="tab"
                              href="#expire_home"
                              role="tab"
                              aria-controls="expire_home"
                              aria-selected="false"
                              onClick={this.handleClick}
                            >
                              Expired <p>{this.state.totalExpiredStock}</p>
                            </a>
                            {/* <a class={this.state.orderHome} id="order_home-tab" data-toggle="tab" href="#order_home" role="tab" aria-controls="order_home" aria-selected="false" onClick={this.handleClick}>Order <br/>Book <h5>{this.state.totalShortagebookStock} added</h5></a> */}
                            <div
                              class={this.state.orderHome}
                              id="order_home-tab"
                              data-toggle="tab"
                              href="#order_home"
                              role="tab"
                              aria-controls="order_home"
                              aria-selected="false"
                              onClick={this.handleClick}
                            >
                              <a href="#">
                                <div class="ord_field">
                                  {" "}
                                  <img src="../images/retailer/OrderBook.svg" />
                                  <p>
                                    <span>
                                      {this.state.totalShortagebookStock} added
                                    </span>{" "}
                                    Order Book
                                  </p>
                                </div>
                              </a>
                            </div>
                            <div class="add_med_btn">
                              <a href="#">
                                <button
                                  type="button"
                                  onClick={this.showAddMedicine}
                                >
                                  {" "}
                                  <img src="../images/retailer/AddNewMedicine.svg" />{" "}
                                  Add New Medicine
                                </button>
                              </a>
                            </div>
                          </div>
                        </nav>
                        <div
                          id="bottom-section"
                          class={this.state.otherSection}
                        >
                          <div class="row">
                            <div class="col-md-12">
                              <div class="manage_search">
                                <div
                                  class={this.state.searchInput}
                                  id="search_input"
                                >
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Search medicine by name"
                                    onKeyUp={this.searchProduct}
                                  />
                                  <div class="input-group-btn">
                                    <div class="btn-group" role="group">
                                      <button class="btn btn-default">
                                        <img src="../images/retailer/search.svg" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class={this.state.searchDownload}>
                                  {/* <a href="#"><p > <img src="../images/retailer/download.svg" />Download XLS</p></a>  */}
                                  <ExcelFile
                                    filename="products downloadedSo"
                                    element={
                                      <a href="#">
                                        {" "}
                                        <p>
                                          <img src="../images/retailer/downloadicon.svg" />
                                          Download Products XLS
                                        </p>
                                      </a>
                                    }
                                  >
                                    <ExcelSheet
                                      data={this.state.exportproductsarray}
                                      name="Order Request"
                                    >
                                      <ExcelColumn
                                        label="MedicineId"
                                        value="medicine_id"
                                      />
                                      <ExcelColumn
                                        label="MedicineName"
                                        value="medicinename"
                                      />
                                      <ExcelColumn
                                        label="Manufacturer"
                                        value="manufacturer"
                                      />
                                      <ExcelColumn label="Form" value="form" />
                                      <ExcelColumn
                                        label="Quantity"
                                        value="available_quantity"
                                      />
                                      <ExcelColumn
                                        label="Batch"
                                        value="batch"
                                      />
                                      <ExcelColumn
                                        label="Expirydate"
                                        value="expiry_date"
                                      />
                                      <ExcelColumn
                                        label="Discount"
                                        value="discount"
                                      />
                                      <ExcelColumn label="MRP" value="mrp" />
                                      <ExcelColumn label="GST" value="GST" />
                                      <ExcelColumn
                                        label="productId"
                                        value="productId"
                                      />
                                    </ExcelSheet>
                                  </ExcelFile>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="tab-content tab_side" id="nav-tabContent">
                            <div
                              class="tab-pane fade show active"
                              id="available_home"
                              role="tabpanel"
                              aria-labelledby="available_home-tab"
                            >
                              <div class="container-fluid">
                                <div class="row stock_body">
                                  <div class="col-md-1 no_padding">
                                    <div class="index_box">
                                      <div class="index_head">
                                        <h2>Index</h2>
                                      </div>
                                      <ul>
                                        <li
                                          class="alpha-list active"
                                          id="all"
                                          onClick={this.handleAll}
                                        >
                                          All
                                        </li>

                                        <li id="available_home-li">
                                          {this.state.alphabetLists}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  <div class="col-md-11 no_padding">
                                    <div class="table-responsive">
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Medicine name</th>
                                            <th>Packaging</th>
                                            <th>Batch</th>
                                            <th>Expiry Date</th>
                                            {this.state.retailerDetails[
                                              "gst_type"
                                            ] == "GST" ? (
                                              <th>GST(CGST + SGST)</th>
                                            ) : (
                                              <th>IGST</th>
                                            )}
                                            <th>Current Stock</th>
                                            <th>Price</th>
                                            <th>Discount</th>
                                            <th>Reorder</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                            this.state
                                              .retailerCurrentMedicineDetailsView
                                          }
                                        </tbody>
                                      </table>
                                      {this.state.availableProductsData.length >
                                      this.state.availableDisplayCount ? (
                                        <div class="text-center" style={{ marginTop: "12px" }}>
                                          <button
                                            type="button"
                                            class="btn btn-outline-primary btn-sm"
                                            onClick={this.handleLoadMoreAvailable}
                                          >
                                            Load More
                                          </button>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="running_home"
                              role="tabpanel"
                              aria-labelledby="running_home-tab"
                            >
                              <div class="container-fluid">
                                <div class="row  stock_body">
                                  <div class="col-md-1 no_padding">
                                    <div class="index_box">
                                      <div class="index_head">
                                        <h2>Index</h2>
                                      </div>
                                      <ul>
                                        <li class="active">All</li>
                                        <li id="running_home-li">
                                          {this.state.alphabetLists}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="col-md-11 no_padding">
                                    <div class="table-responsive">
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Medicine Name</th>
                                            <th>Batch</th>
                                            <th>Expiry Date</th>
                                            <th>GST</th>
                                            <th>Current Stock</th>
                                            <th>Price</th>
                                            {/* <th>Discount</th> */}
                                            <th class="input_td">Reorder</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state
                                            .retailerLowStockCurrentMedicineDetailsView ? (
                                            this.state
                                              .retailerLowStockCurrentMedicineDetailsView
                                          ) : (
                                            <React.Fragment>
                                              <td>No Products</td>
                                            </React.Fragment>
                                          )}
                                        </tbody>
                                      </table>
                                      {this.state.lowStockProductsData.length >
                                      this.state.lowStockDisplayCount ? (
                                        <div class="text-center" style={{ marginTop: "12px" }}>
                                          <button
                                            type="button"
                                            class="btn btn-outline-primary btn-sm"
                                            onClick={this.handleLoadMoreLowStock}
                                          >
                                            Load More
                                          </button>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="out_home"
                              role="tabpanel"
                              aria-labelledby="out_home-tab"
                            >
                              <div class="container-fluid">
                                <div class="row  stock_body">
                                  <div class="col-md-1 no_padding">
                                    <div class="index_box">
                                      <div class="index_head">
                                        <h2>Index</h2>
                                      </div>
                                      <ul>
                                        <li class="active">All</li>
                                        <li id="out_home-li">
                                          {this.state.alphabetLists}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="col-md-11 no_padding">
                                    <div class="table-responsive">
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Medicine Name</th>
                                            <th>Batch</th>
                                            <th>Expiry Date</th>
                                            <th>GST</th>
                                            <th>Current Stock</th>
                                            <th>Price</th>
                                            <th>Reorder</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {/* <td> */}
                                          {this.state
                                            .retailerNoStockCurrentMedicineDetailsView
                                            ? this.state
                                                .retailerNoStockCurrentMedicineDetailsView
                                            : " No results found"}
                                          {/* </td> */}
                                        </tbody>
                                      </table>
                                      {this.state.outStockProductsData.length >
                                      this.state.outStockDisplayCount ? (
                                        <div class="text-center" style={{ marginTop: "12px" }}>
                                          <button
                                            type="button"
                                            class="btn btn-outline-primary btn-sm"
                                            onClick={this.handleLoadMoreOutStock}
                                          >
                                            Load More
                                          </button>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="expire_home"
                              role="tabpanel"
                              aria-labelledby="order_home-tab"
                            >
                              <div class="container-fluid">
                                <div class="row  stock_body">
                                  <div class="col-md-1 no_padding">
                                    <div class="index_box">
                                      <div class="index_head">
                                        <h2>Index</h2>
                                      </div>
                                      <ul>
                                        <li class="active">All</li>
                                        <li id="Expire_home-li">
                                          {this.state.alphabetLists}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="col-md-11 no_padding">
                                    <div class="table-responsive">
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Medicine Name</th>
                                            <th>Batch</th>
                                            <th>Expiry Date</th>
                                            <th>GST</th>
                                            <th>Current Stock</th>
                                            <th>Price</th>
                                            {/* <th>Return</th> */}
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state
                                            .retailerExpiredStockCurrentMedicineDetailsView !=
                                          ""
                                            ? this.state
                                                .retailerExpiredStockCurrentMedicineDetailsView
                                            : "No results found "}
                                        </tbody>
                                      </table>
                                      {this.state.expiredStockProductsData.length >
                                      this.state.expiredStockDisplayCount ? (
                                        <div class="text-center" style={{ marginTop: "12px" }}>
                                          <button
                                            type="button"
                                            class="btn btn-outline-primary btn-sm"
                                            onClick={this.handleLoadMoreExpiredStock}
                                          >
                                            Load More
                                          </button>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="order_home"
                              role="tabpanel"
                              aria-labelledby="order_home-tab"
                            >
                              <div class="container-fluid">
                                <div class="row  stock_body">
                                  <div class="col-md-1 no_padding">
                                    <div class="index_box">
                                      <div class="index_head">
                                        <h2>Index</h2>
                                      </div>
                                      <ul>
                                        <li class="active">All</li>
                                        <li id="order_home-li">
                                          {this.state.alphabetLists}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="col-md-11 no_padding">
                                    <div class="table-responsive">
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>Medicine</th>
                                            <th>Add Quantity</th>
                                            <th class="order_all">
                                              <input
                                                type="checkbox"
                                                id="orderAll"
                                                onChange={
                                                  this.orderAllShortageBook
                                                }
                                              />
                                              Order All
                                            </th>
                                            <th class="delete_head">
                                              <img
                                                src="../images/retailer/deleteAll.svg"
                                                onClick={
                                                  this.deleteAllShortageBook
                                                }
                                              />{" "}
                                              Delete All
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                            this.state
                                              .retailerShortagebookProductsList
                                          }
                                        </tbody>
                                      </table>
                                      <div
                                        class={this.state.showFinalOrderButton}
                                      >
                                        <p>
                                          Total{" "}
                                          {this.state.shortageBookItemsCount}{" "}
                                          items added{" "}
                                          <h5 onClick={this.previewOrder}>
                                            <img src="../images/retailer/finalOrder.svg" />{" "}
                                            Final Order
                                          </h5>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* bottomsection end */}
                      </div>
                    </div>
                  </div>
                </section>

                <section
                  id="add_medicine"
                  class={this.state.addMedicineSection}
                >
                  <form
                    onSubmit={this.checkAddMedicineSubmit.bind(this)}
                    id="addMedicines"
                  >
                    <div class="add_med_content">
                      <div class="container">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="add_med_head">
                              <h2>Add Medicine </h2>
                              <div class="upload_items">
                                <ExcelFile
                                  element={
                                    <a href="#">
                                      {" "}
                                      <p>
                                        <img src="../images/retailer/downloadicon.svg" />
                                        Download Products XLS
                                      </p>
                                    </a>
                                  }
                                >
                                  <ExcelSheet
                                    data={this.state.exportproductsarray}
                                    name="Order Request"
                                  >
                                    <ExcelColumn
                                      label="MedicineId"
                                      value="medicine_id"
                                    />
                                    <ExcelColumn
                                      label="MedicineName"
                                      value="medicinename"
                                    />
                                    <ExcelColumn
                                      label="Manufacturer"
                                      value="manufacturer"
                                    />
                                    <ExcelColumn label="Form" value="form" />
                                    <ExcelColumn
                                      label="Quantity"
                                      value="available_quantity"
                                    />
                                    <ExcelColumn label="Batch" value="batch" />
                                    <ExcelColumn
                                      label="Expirydate"
                                      value="expiry_date"
                                    />
                                    <ExcelColumn
                                      label="Discount"
                                      value="discount"
                                    />
                                    <ExcelColumn label="MRP" value="mrp" />
                                    <ExcelColumn label="GST" value="GST" />
                                    <ExcelColumn
                                      label="productId"
                                      value="productId"
                                    />
                                  </ExcelSheet>
                                </ExcelFile>
                              </div>
                              <div class="upload_items">
                                <a href="#" onClick={this.showUpload}>
                                  <p>
                                    {" "}
                                    <img src="../images/retailer/uploadicon.svg" />
                                    Upload XLS
                                  </p>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="add_med_form">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group add_group add_form product_field">
                                <input
                                  type="text"
                                  class="form-control "
                                  autocomplete="off"
                                  name="product_name"
                                  id="medicineList"
                                  placeholder="Product name"
                                  onKeyUp={this.fetchmedicinedata}
                                />

                                <ul id="searchResult">
                                  {this.state.medicineOptions}
                                </ul>
                              </div>
                              <span className="cRed">
                                {this.state.errors["selectedMedicine"]}
                              </span>
                            </div>
                            <div class={this.state.showfields}>
                              <div class="form-group add_group col-md-2">
                                <input
                                  type="text"
                                  class="form-control"
                                  name="qty"
                                  id="qty_textfield"
                                  placeholder="Quantity"
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "qty"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["qty"]}
                                </div>
                              </div>

                              <div class="form-group add_group col-md-2">
                                <input
                                  type="text"
                                  class="form-control"
                                  name="batchNumber"
                                  id="batch_textfield"
                                  placeholder="Batch number"
                                  onKeyPress={(event) => {
                                    if (!/^[A-Za-z0-9-_]*$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "batchNumber"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["batchNumber"]}
                                </div>
                              </div>

                              <div class="form-group add_group col-md-2">
                                <input
                                  type="month"
                                  class="form-control"
                                  name="expireDate"
                                  id="txtDate"
                                  onKeyPress={(event) => {
                                    if (/[^0-9-]/g.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  placeholder="Expiry Date"
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "expireDate"
                                  )}
                                />
                                <div>Expiry Date</div>
                                <div className="cRed">
                                  {this.state.errors["expireDate"]}
                                </div>
                              </div>

                              <div class="form-group add_group col-md-2">
                                <input
                                  type="text"
                                  class="form-control"
                                  name="mrp"
                                  min="0"
                                  // oninput="this.value = Math.abs(this.value)"
                                  onInput={(e) => {
                                    // Remove invalid characters, allow only digits and one dot
                                    let val = e.target.value.replace(
                                      /[^0-9.]/g,
                                      ""
                                    );
                                    const parts = val.split(".");

                                    // Allow only one dot
                                    if (parts.length > 2) {
                                      val = parts[0] + "." + parts[1];
                                    }

                                    // Restrict to 2 decimals
                                    if (parts[1] && parts[1].length > 2) {
                                      val =
                                        parts[0] + "." + parts[1].slice(0, 2);
                                    }

                                    e.target.value = val;
                                  }}
                                  id="mrp_textfield"
                                  placeholder="MRP"
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "mrp"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["mrp"]}
                                </div>
                              </div>
                              {/* <div class="form-group add_group col-md-2">
                        <input type="text" class="form-control" name="hsn" placeholder="HSN Number" onConChange={this.handleChangeInput.bind(
                                        this,
                                        "hsn"
                                      )}/>
                               <div className="cRed">
        {this.state.errors["hsn"]}
        </div>        
                    </div> */}

                              <div class="form-group add_group col-md-2">
                                <input
                                  type="text"
                                  class="form-control"
                                  name="discount"
                                  id="discount_textfield"
                                  minlength="1"
                                  maxlength="2"
                                  placeholder="Discount"
                                  onKeyPress={(event) => {
                                    if (!/[0-9.]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "discount"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["discount"]}
                                </div>
                              </div>
                              <div class="form-group add_group col-md-2">
                                <input
                                  type="number"
                                  class="form-control"
                                  name="GSTAmt"
                                  step="0.00000001"
                                  min="0"
                                  oninput="this.value = Math.abs(this.value)"
                                  id="GSTAmt_textfield"
                                  placeholder="GSTAmt%"
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "GSTAmt"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["GSTAmt"]}
                                </div>
                              </div>
                              {/* <div class="form-group add_group col-md-2">
                                <input
                                  type="number"
                                  class="form-control"
                                  name="IGST"
                                  step="0.00000001"
                                  min="0.00000001"
                                  id="IGST_textfield"
                                  placeholder="IGST"
                                  onChange={this.handleChangeInput.bind(
                                    this,
                                    "IGST"
                                  )}
                                />
                                <div className="cRed">
                                  {this.state.errors["IGST"]}
                                </div>
                              </div> */}
                            </div>
                            {/* <div class="col-md-2">
                              <select
                                name="GST"
                                className="form-control"
                                value={this.state.fields.GST}
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "GST"
                                )}
                              >
                                <option
                                  value=""
                                  disabled selected>
                                  Select GST
                                </option>
                                <option
                                  value="GST"
                                >
                                  GST(CGST + SGST)
                                </option>
                                <option
                                  value="IGST"
                                >
                                  IGST
                                </option>
                              </select>
                              <div className="cRed">
                                {this.state.errors["GST"]}
                              </div>
                            </div> */}
                          </div>
                        </div>

                        <div class={this.state.requestbtn}>
                          <div class="row">
                            <div class="form-group add_group col-md-4">
                              <input
                                type="text"
                                class="form-control"
                                name="qty"
                                placeholder="Manufacturer name"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "manufacturer"
                                )}
                              />
                              <div className="cRed">
                                {this.state.errors["manufacturer"]}
                              </div>
                            </div>

                            <div class="form-group add_group col-md-4">
                              <input
                                type="text"
                                class="form-control"
                                name="batchNumber"
                                placeholder="UOM"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "UOM"
                                )}
                              />
                              <div className="cRed">
                                {this.state.errors["UOM"]}
                              </div>
                            </div>
                            <div class="form-group add_group col-md-4">
                              <input
                                type="text"
                                class="form-control"
                                name="strength"
                                placeholder="strength"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "strength"
                                )}
                              />
                              <div className="cRed">
                                {this.state.errors["strength"]}
                              </div>
                            </div>
                            <div class="form-group add_group col-md-4">
                              <input
                                type="number"
                                class="form-control"
                                name="expireDate"
                                placeholder="MRP"
                                min="0"
                                oninput="this.value = Math.abs(this.value)"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "MRP"
                                )}
                              />

                              <div className="cRed">
                                {this.state.errors["MRP"]}
                              </div>
                            </div>

                            <div class="form-group add_group col-md-4">
                              <input
                                type="text"
                                class="form-control"
                                name="form"
                                placeholder="Medicine form"
                                onChange={this.handleChangeInput.bind(
                                  this,
                                  "form"
                                )}
                              />

                              <div className="cRed">
                                {this.state.errors["MRP"]}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="add_med_btns">
                          <div class="clear_btn">
                            <a href="#">
                              <button type="button" onClick={this.clearAll}>
                                Clear All
                              </button>
                            </a>
                          </div>
                          <div class={this.state.updatebtn}>
                            <a href="#">
                              {" "}
                              <button type="submit">Update</button>
                            </a>
                          </div>

                          <div class={this.state.requestbtn}>
                            <a href="#">
                              {" "}
                              <button
                                type="button"
                                onClick={this.addProductRequest}
                              >
                                Send Add Request
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </section>

                <section id="final_order" class={this.state.finalOrder}>
                  <div class="final_content">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="final_back">
                            <a href="#" onClick={this.showOrderBook}>
                              {" "}
                              <h2>
                                <img src="../images/retailer/back-arrow.jpg" />
                                Back to Order Book
                              </h2>
                            </a>
                          </div>
                          <div class="final_head">
                            <h2>Final Order list</h2>

                            <div class="final_ord_book">
                              <ExcelFile
                                filename="Final Order List"
                                element={
                                  <a href="#">
                                    {" "}
                                    <p>
                                      <img src="../images/retailer/downloadicon.svg" />
                                      Download XLS
                                    </p>
                                  </a>
                                }
                              >
                                <ExcelSheet
                                  data={this.state.finalorderarray}
                                  name="Order Request"
                                >
                                  <ExcelColumn label="Name" value="name" />
                                  <ExcelColumn
                                    label="Manufacturer"
                                    value="manufacturer"
                                  />
                                  <ExcelColumn
                                    label="Quantity"
                                    value="quantity"
                                  />
                                </ExcelSheet>
                              </ExcelFile>
                              <a href="#" onClick={this.printDiv}>
                                {" "}
                                <p>
                                  <img src="../images/retailer/print.svg" />{" "}
                                  Print
                                </p>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="final_ord_details" id="final_ord_details">
                            {this.state.retailerFinalOrderMedicineDetailsView}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <ToastContainer />
        </section>{" "}
        <Footer />
      </main>
    );
  }
}
